import clsx from "classnames";
import { buildFooterNavigation } from "../../../constants/footerNavigation";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TypographyColor } from "../../../constants/typography";
import { Icon } from "../../core/Icon/Icon";
import { Typography } from "../../core/Typography/Typography";
import { useAppSelector } from "../../hooks";
import { useStyles } from "./VerticalFooterNavigation.style";
import { PageRoutes } from "../../../constants/historyGaming";

const VerticalFooterNavigation: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme } = useAppSelector((state) => state.theme);

  const items = useMemo(() => {
    return buildFooterNavigation(theme?.pages?.bottomNavbar || []);
  }, [theme?.pages?.bottomNavbar]);

  return (
    <div className={classes.root}>
      {items.map((item) => {
        return (
          <button
            key={item.id}
            className={classes.item}
            data-testid={`${item.id}-tab`}
            onClick={() => {
              navigate(item.path);
            }}
          >
            {(window.location.pathname === item.path ||
              (window.location.pathname === PageRoutes.Guest &&
                item.path === PageRoutes.HomePage)) && (
                <div className={classes.active} />
              )}
            <Icon name={item.icon} className={classes.icon} />
            <Typography
              color={TypographyColor.Primary}
              className={classes.title}
              lines={1}
            >
              {t(item.title)}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

export default VerticalFooterNavigation;
